import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { OfflineModeProvider } from './features/offline/state/OfflineModeProvider';
import 'sweetalert2/dist/sweetalert2.min.css';
import { registerSW } from 'virtual:pwa-register';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <OfflineModeProvider>
      <App />
    </OfflineModeProvider>
  </React.StrictMode>
);

if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  const createBanner = (options) => {
    const existing = document.getElementById('pwa-update-banner');
    if (existing) {
      existing.remove();
    }
    const container = document.createElement('div');
    container.id = 'pwa-update-banner';
    container.style.position = 'fixed';
    container.style.left = '0';
    container.style.right = '0';
    container.style.bottom = '12px';
    container.style.zIndex = '9999';
    container.style.display = 'flex';
    container.style.justifyContent = 'center';
    container.style.pointerEvents = 'none';

    const panel = document.createElement('div');
    panel.style.pointerEvents = 'auto';
    panel.style.display = 'flex';
    panel.style.alignItems = 'center';
    panel.style.gap = '12px';
    panel.style.padding = '12px 16px';
    panel.style.borderRadius = '12px';
    panel.style.background = '#111827';
    panel.style.color = 'white';
    panel.style.boxShadow = '0 10px 30px rgba(0,0,0,0.25)';
    panel.style.fontSize = '13px';
    panel.style.fontWeight = '600';

    const text = document.createElement('span');
    text.textContent = options.message;
    panel.appendChild(text);

    if (options.actionLabel && options.onAction) {
      const btn = document.createElement('button');
      btn.textContent = options.actionLabel;
      btn.style.background = '#4f46e5';
      btn.style.color = 'white';
      btn.style.border = 'none';
      btn.style.borderRadius = '8px';
      btn.style.padding = '8px 12px';
      btn.style.fontWeight = '700';
      btn.style.cursor = 'pointer';
      btn.onclick = (event) => {
        event.preventDefault();
        options.onAction();
        container.remove();
      };
      panel.appendChild(btn);
    }

    const close = document.createElement('button');
    close.textContent = '×';
    close.setAttribute('aria-label', 'Dismiss update notice');
    close.style.background = 'transparent';
    close.style.color = '#cbd5e1';
    close.style.border = 'none';
    close.style.fontSize = '16px';
    close.style.cursor = 'pointer';
    close.onclick = (event) => {
      event.preventDefault();
      container.remove();
    };
    panel.appendChild(close);

    container.appendChild(panel);
    document.body.appendChild(container);
  };

  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      createBanner({
        message: 'A new version is available.',
        actionLabel: 'Reload',
        onAction: () => updateSW(true),
      });
    },
    onOfflineReady() {
      console.info('App is ready for offline use.');
    },
  });
}
